import { render, staticRenderFns } from "./AccredInfo.vue?vue&type=template&id=679ad170&scoped=true&"
import script from "./AccredInfo.vue?vue&type=script&lang=js&"
export * from "./AccredInfo.vue?vue&type=script&lang=js&"
import style0 from "./AccredInfo.vue?vue&type=style&index=0&id=679ad170&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679ad170",
  null
  
)

export default component.exports